import apiService from "../../api-service";

const REQUEST_BASE_API = process.env.REACT_APP_API_URI + "/report";

export class HrOnlineService {
  static async getReportEmployeeCountByTypeList(data: any) {
    const response = await apiService().get(
      `${REQUEST_BASE_API}/employee_count_by_type_list`,
      { params: data }
    );
    return response.data;
  }

  static async getReportEmployeeCountByGenderList(data: any) {
    const response = await apiService().get(
      `${REQUEST_BASE_API}/employee_count_by_gender_list`,
      { params: data }
    );
    return response.data;
  }

  static async getReportEmployeeCountByGenerationList(data: any) {
    const response = await apiService().get(
      `${REQUEST_BASE_API}/employee_count_by_generation_list`,
      { params: data }
    );
    return response.data;
  }

  static async getReportEmployeeCountByLevelList(data: any) {
    const response = await apiService().get(
      `${REQUEST_BASE_API}/employee_count_by_level_list`,
      { params: data }
    );
    return response.data;
  }

  static async getReportEmployeeCountByEducationLevelList(data: any) {
    const response = await apiService().get(
      `${REQUEST_BASE_API}/employee_count_by_education_level_list`,
      { params: data }
    );
    return response.data;
  }

  static async getReportEmployeeCountByDepartmentOfficesList(data: any) {
    const response = await apiService().get(
      `${REQUEST_BASE_API}/employee_count_by_department_offices_list`,
      { params: data }
    );
    return response.data;
  }

  static async getReportRetirementTrendList(data: any) {
    const response = await apiService().get(
      `${REQUEST_BASE_API}/retirement_trend_list`,
      { params: data }
    );
    return response.data;
  }

  static async getReportEmployeeLevelTrainingKeyCoursesList(data: any) {
    const response = await apiService().get(
      `${REQUEST_BASE_API}/employee_level_training_key_courses_list`,
      { params: data }
    );
    return response.data;
  }

  static async getReportRetirementTrendNext3YearsOTKList(data: any) {
    const response = await apiService().get(
      `${REQUEST_BASE_API}/retirement_trend_next_3_years_otk_list`,
      { params: data }
    );
    return response.data;
  }

  static async getReportRetirementTrendNext3YearsList(data: any) {
    const response = await apiService().get(
      `${REQUEST_BASE_API}/retirement_trend_next_3_years_list`,
      { params: data }
    );
    return response.data;
  }

  static async getReportManpowerFrameworkOverviewList(data: any) {
    const response = await apiService().get(
      `${REQUEST_BASE_API}/manpower_framework_overview_list`,
      { params: data }
    );
    return response.data;
  }

  static async getReportRetirementTrendNext3YearsOTKByManagerList(data: any) {
    const response = await apiService().get(
      `${REQUEST_BASE_API}/retirement_trend_next_3_years_otk_by_manager_list`,
      { params: data }
    );
    return response.data;
  }

  static async getReportRetirementTrendNext3YearsOTKByPositionList(data: any) {
    const response = await apiService().get(
      `${REQUEST_BASE_API}/retirement_trend_next_3_years_otk_by_position_list`,
      { params: data }
    );
    return response.data;
  }
}
